export default __webpack_public_path__ + "static/media/commonocean-dc.7ba25146.md";